import { Component, Watch } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';
import { ApartmentPriceTable } from '../../../components/apartment-price-table/apartment-price-table';
import { ApartmentSearchStatsDTO } from '../../../model/ApartmentSearchStatsDTO';
import { ApartmentSearchDTO } from '../../../model/ApartmentSearchDTO';
import { ApartmentSearchFilterDTO } from '../../../model/ApartmentSearchFilterDTO';
import { ApartmentSearchSortType } from '../../../enums/ApartmentSearchSortType';
import { ApartmentSearchSortDirection } from '../../../enums/ApartmentSearchSortDirection';
import { formatDateLocal } from '@/helpers/dates';

@Block()
@Component({
	components: {
		ApartmentPriceTable
	}
})
export class ApartmentSearchResultBlock extends BaseBlock {
	results: ApartmentSearchDTO[] = null;
	nextStats: ApartmentSearchStatsDTO = null;
	limit = 50;
	offset = 0;

	fetchingResults: boolean = false;

	@Watch('$route', {immediate: true})
	protected searchFilterChanged() {
		if (this.shouldSearch) {
			this.load();
		}
	}

	get shouldSearch() {
		return this.$route.query.search === 'true';
	}

	get searchFilter() {
		return this.$route.query as ApartmentSearchFilterDTO;
	}

	get searchSort() {
		return parseInt(this.$route.query.sort) as ApartmentSearchSortType || ApartmentSearchSortType.TotalPrice;
	}

	get searchSortDirection() {
		return parseInt(this.$route.query.sortDirection) as ApartmentSearchSortDirection || ApartmentSearchSortDirection.Up;
	}

	get currentDateFormated() {
		return formatDateLocal(this.getCurrentDate());
	}

	load() {
		this.results = null;

		this.limit = 50;
		this.offset = 0;
		this.fetchResults();
	}

	loadMore() {
		this.offset += this.limit;
		this.fetchResults();
	}

	async fetchResults() {
		this.fetchingResults = true;

		const results = await this.$apartmentService.fetchApartments(
			this.searchFilter,
			this.searchSort,
			this.searchSortDirection,
			this.limit,
			this.offset
		);

		const nextStats = await this.$apartmentService.fetchSearchStats(
			this.searchFilter,
			this.limit,
			this.offset + this.limit
		);

		if (! this.results) {
			this.results = results;
		} else {
			this.results = this.results.concat(results);
		}

		this.nextStats = nextStats;

		this.fetchingResults = false;
	}
}

export default ApartmentSearchResultBlock;
